export default __webpack_public_path__ + "static/media/maduro1.4c99c84e.png";